import styles from './SignUpForm.scss';
import { BaseButton } from '@/components/atoms/button/BaseButton';
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { VALIDATE_RULES } from '@/config/validateRuleConfig';
import { BaseInput } from '@/components/atoms/input/BaseInput';
import { TERMS_URL } from '@/config/urlConfig';
import Link from 'next/link';
import { pagesPath } from '@/lib/$path';
import { UseApiContextState } from '@/hooks/api';
import { AuthDialogCard } from '@/components/atoms/card/AuthDialogCard';

type FromProps = JSX.IntrinsicElements['form'];
type Props = Omit<FromProps, 'onSubmit'> & {
  onSubmit: (e?: React.BaseSyntheticEvent) => Promise<void>;
  register: UseFormRegister<FormValues>;
  errors: FieldErrors<FormValues>;
};

type SignUpParameters = Parameters<UseApiContextState['api']['users']['auth']['sign_up']['$post']>[0];

export type FormValues = SignUpParameters['body'];

/** organisms/SignUpForm */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const SignUpForm: React.FC<Props> = ({ children, register, errors, onSubmit, ...props }) => {
  return (
    <AuthDialogCard className="card">
      <form {...props} className="sign-up-form">
        <BaseInput
          placeholder="メールアドレスを入力"
          type="email"
          error={errors?.email?.message}
          register={register('email', VALIDATE_RULES.SIGN_UP_FORM.email)}
        />
        <BaseButton type="submit" className="sign-up-button" onClick={onSubmit}>
          登録
        </BaseButton>
      </form>
      <p className="sign-up-form-attention">
        新規登録することにより、当社の
        <a href={TERMS_URL} target="_blank" rel="noreferrer">
          利用規約
        </a>
        および
        <Link href={pagesPath.privacy.$url()}>
          <a target="_blank" rel="noreferrer">
            プライバシーポリシー
          </a>
        </Link>
        に同意したとみなされます。
      </p>
      <style jsx>{styles}</style>
    </AuthDialogCard>
  );
};
